import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout, { escopoContrato, veDashboard } from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Ordens from "@/pages/Ordens";
import OrdemDetalhe from "@/pages/OrdemDetalhe";
import OrdemImprimir from "@/pages/OrdemImprimir";
import BoletimMedicao from "@/pages/BoletimMedicao";
import Contratos from "@/pages/Contratos";
import ContratoDetalhe from "@/pages/ContratoDetalhe";
import PropostaContrato from "@/pages/PropostaContrato";
import PrevisaoCusto from "@/pages/PrevisaoCusto";
import CronogramaContrato from "@/pages/CronogramaContrato";
import BoletimMedicaoContrato from "@/pages/BoletimMedicaoContrato";
import Clientes from "@/pages/Clientes";
import Licitacoes from "@/pages/Licitacoes";
import MigracaoMultiempresa from "@/pages/MigracaoMultiempresa";
import Orcamentos from "@/pages/Orcamentos";
import OrcamentoDetalhe from "@/pages/OrcamentoDetalhe";
import Propostas from "@/pages/Propostas";
import PropostaDetalhe from "@/pages/PropostaDetalhe";
import { ROLES_SEM_FINANCEIRO } from "@/components/pcp";

function HomePorPerfil() {
  const { user } = useAuth();
  if (veDashboard(user)) return <Dashboard />;
  return <Navigate to={user?.role === "fiscal" || escopoContrato(user) ? "/contratos" : "/ordens"} replace />;
}
function SoComValores({ children }) {
  const { user } = useAuth();
  return user && ROLES_SEM_FINANCEIRO.includes(user.role) ? <Navigate to="/" replace /> : children;
}
import Apontamento from "@/pages/Apontamento";
import ApontamentoPintura from "@/pages/ApontamentoPintura";
import ApontamentoPlacas from "@/pages/ApontamentoPlacas";
import FilaOffline from "@/pages/FilaOffline";
import Apontamentos from "@/pages/Apontamentos";
import Programacao from "@/pages/Programacao";
import Equipes from "@/pages/Equipes";
import Empresas from "@/pages/Empresas";
import Composicoes from "@/pages/Composicoes";
import Insumos from "@/pages/Insumos";
import NaoConformidades from "@/pages/NaoConformidades";
import Relatorios from "@/pages/Relatorios";
import OrdemFotos from "@/pages/OrdemFotos";
import ApontamentoTrecho from "@/pages/ApontamentoTrecho";
import ApontamentoCapina from "@/pages/ApontamentoCapina";
import Importacao from "@/pages/Importacao";
import Usuarios from "@/pages/Usuarios";
import Lixeira from "@/pages/Lixeira";
import { Toaster } from "sonner";
import InstallPWA from "@/components/InstallPWA";
import OfflineSync from "@/components/OfflineSync";
import "@/App.css";

function ProtectedShell() {
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<HomePorPerfil />} />
        <Route path="/ordens" element={<Ordens />} />
        <Route path="/ordens/:id" element={<OrdemDetalhe />} />
        <Route path="/ordens/:id/imprimir" element={<OrdemImprimir />} />
        <Route path="/ordens/:id/bdm" element={<BoletimMedicao />} />
        <Route path="/ordens/:id/fotos" element={<OrdemFotos />} />
        <Route path="/contratos" element={<Contratos />} />
        <Route path="/contratos/:id" element={<ContratoDetalhe />} />
        <Route path="/contratos/:id/proposta" element={<SoComValores><PropostaContrato /></SoComValores>} />
        <Route path="/contratos/:id/previsoes/nova" element={<SoComValores><PrevisaoCusto /></SoComValores>} />
        <Route path="/previsoes/:pid" element={<SoComValores><PrevisaoCusto /></SoComValores>} />
        <Route path="/contratos/:id/cronograma" element={<SoComValores><CronogramaContrato /></SoComValores>} />
        <Route path="/medicoes/:id/boletim" element={<BoletimMedicaoContrato />} />
        <Route path="/apontamento" element={<Apontamento />} />
        <Route path="/apontamento-pintura" element={<ApontamentoPintura />} />
        <Route path="/apontamento-tachas" element={<ApontamentoTrecho modo="tachas" />} />
        <Route path="/apontamento-defensas" element={<ApontamentoTrecho modo="defensas" />} />
        <Route path="/apontamento-capina" element={<ApontamentoCapina />} />
        <Route path="/apontamento-placas" element={<ApontamentoPlacas />} />
        <Route path="/fila-offline" element={<FilaOffline />} />
        <Route path="/apontamentos" element={<Apontamentos />} />
        <Route path="/programacao" element={<Programacao />} />
        <Route path="/equipes" element={<Equipes />} />
        <Route path="/empresas" element={<Empresas />} />
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/licitacoes" element={<Licitacoes />} />
        <Route path="/orcamentos" element={<SoComValores><Orcamentos /></SoComValores>} />
        <Route path="/orcamentos/:id" element={<SoComValores><OrcamentoDetalhe /></SoComValores>} />
        <Route path="/propostas" element={<SoComValores><Propostas /></SoComValores>} />
        <Route path="/propostas/:id" element={<SoComValores><PropostaDetalhe /></SoComValores>} />
        <Route path="/migracao-multiempresa" element={<MigracaoMultiempresa />} />
        <Route path="/composicoes" element={<Composicoes />} />
        <Route path="/insumos" element={<Insumos />} />
        <Route path="/nao-conformidades" element={<NaoConformidades />} />
        <Route path="/relatorios" element={<Relatorios />} />
        <Route path="/importacao" element={<Importacao />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/lixeira" element={<Lixeira />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppLayout>
  );
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 32 }}>Carregando…</div>;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <InstallPWA />
        <OfflineSync />
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/*" element={<ProtectedShell />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
